import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { UrineOutputAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-urine-output-slot',
    templateUrl: './urine-output-slot.component.html',
    styleUrl: './urine-output-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrineOutputSlotComponent implements SheetSlotComponentBase {

	action!: UrineOutputAction;
	value!: string | null;

	@Input('action') set updateAction(action: UrineOutputAction | null) {
		this.action = action as UrineOutputAction;
		this.value = this.action.volume?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}
